export const flatResponseEdges = <T>(data: { node: T }[]): T[] => {
  return data.map(item => item.node);
};
